import * as yup from 'yup';
import { ETLExecutionModeEnum, ETLJobRecurrenceEnum } from '~/api/types';

export const MAX_JOB_NAME_LENGTH = 128;

const scheduleETLJobSchema: yup.AnyObjectSchema = yup
  .object({
    projectId: yup.number().required(),

    name: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .required('Job name is required')
      .max(MAX_JOB_NAME_LENGTH, `Job name must be at most ${MAX_JOB_NAME_LENGTH} characters`)
      .matches(/^[A-Za-z0-9_-]+$/, 'Only letters, numbers, hyphens, and underscores are allowed'),

    notebook_id: yup.string().required('Workspace is required'),

    file_name: yup.string().required('Code file is required'),

    execution_mode: yup
      .mixed<ETLExecutionModeEnum>()
      .oneOf(Object.values(ETLExecutionModeEnum) as ETLExecutionModeEnum[], 'Execution mode is required')
      .required('Execution mode is required'),

    start_date: yup.date().when('execution_mode', {
      is: ETLExecutionModeEnum.SCHEDULE,
      then: (schema) => schema.required('Start date is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    time: yup.string().when('execution_mode', {
      is: ETLExecutionModeEnum.SCHEDULE,
      then: (schema) =>
        schema.required('Time is required').matches(/^([01]\d|2[0-3]):[0-5]\d$/, 'Time must be in HH:mm format'),
      otherwise: (schema) => schema.notRequired(),
    }),

    frequency: yup.mixed<ETLJobRecurrenceEnum>().when('execution_mode', {
      is: ETLExecutionModeEnum.SCHEDULE,
      then: (schema) =>
        schema.required('Recurrence is required').oneOf(Object.values(ETLJobRecurrenceEnum) as ETLJobRecurrenceEnum[]),
      otherwise: (schema) => schema.notRequired(),
    }),

    end_date: yup.date().when(['execution_mode', 'recurrence', 'start_date'], {
      is: (execution_mode: ETLExecutionModeEnum, recurrence: ETLJobRecurrenceEnum, start_date?: Date) =>
        execution_mode === ETLExecutionModeEnum.SCHEDULE &&
        [ETLJobRecurrenceEnum.DAILY, ETLJobRecurrenceEnum.WEEKLY, ETLJobRecurrenceEnum.MONTHLY].includes(recurrence) &&
        !!start_date,
      then: (schema) => schema.min(yup.ref('start_date'), 'End date cannot be before start date'),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
  .required();

export default scheduleETLJobSchema;
